
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Tooltipcomponent3912263644",
      {"classes":{"root":"Tooltipcomponent3912263644__root","tooltipWrapper":"Tooltipcomponent3912263644__tooltipWrapper","tooltip":"Tooltipcomponent3912263644__tooltip","tooltipArrow":"Tooltipcomponent3912263644__tooltipArrow"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  